
import { defineComponent, ref } from "vue";
import isMobile from "ismobilejs";

export default defineComponent({
  props: {
    demo: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const mobile =
      isMobile(window.navigator).phone || isMobile(window.navigator).tablet;
    const isOpen = ref<boolean>(false);
    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    const open = () => {
      isOpen.value = true;
    };

    const close = () => {
      isOpen.value = false;
    };

    return {
      mobile,
      toggle,
      open,
      close,
      isOpen,
    };
  },
});
